// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchPopUp_wrapper__4OdHX","products":"SearchPopUp_products__9kW6E"};